export default __webpack_public_path__ + "static/media/318.e1f44b2f.png";